import { useEffect } from 'react';

/** Mounting confirms the app bundle booted; worker updates affect future navigations only. */
export default function AppBootRecovery() {
  useEffect(() => {
    try { sessionStorage.removeItem('jeddle-offline-auto-reload'); } catch (_) {}
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
    // Generated after Parcel builds: keep a stable URL for updates and rollback.
    const worker = new URL('/navigation-recovery-sw.js', window.location.origin);
    navigator.serviceWorker.register(worker.href, { scope: '/', updateViaCache: 'none' }).catch(() => {});
  }, []);
  return null;
}
